import { render } from "./TrammellTech.vue?vue&type=template&id=21942ce1&ts=true"
import script from "./TrammellTech.vue?vue&type=script&lang=ts"
export * from "./TrammellTech.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__